export enum CountryName {
	UNITED_KINGDOM = 'United Kingdom',
	IRELAND = 'Ireland',
	ESPANA = 'España',
	FRANCE = 'France',
	GUADELOUPE = 'Guadeloupe',
	GUYANNE = 'Guyanne',
	MARTINIQUE = 'Martinique',
	MAYOTTE = 'Mayotte',
	ILE_DE_LA_REUNION = 'Ile de la Réunion',
	POLYNESIE_FRANCAISE = 'Polynésie française',
	MONACO = 'Monaco',
	AUSTRIA = 'Austria',
	BELGIQUE = 'Belgique',
	CANADA = 'Canada',
	CROATIA = 'Croatia',
	DENMARK = 'Denmark',
	FINLAND = 'Finland',
	GERMANY = 'Germany',
	GREECE = 'Greece',
	ITALIA = 'Italia',
	LUXEMBOURG = 'Luxembourg',
	MALTA = 'Malta',
	NEDERLAN = 'Nederlan',
	POLSKA = 'Polska',
	PORTUGAL = 'Portugal',
	NORWAY = 'Norway',
	SWEDEN = 'Sweden',
	SWITZERLAND = 'Switzerland'
}

export enum CountryISO {
	GB = 'GB',
	IE = 'IE',
	ES = 'ES',
	FR = 'FR',
	GP = 'GP',
	GF = 'GF',
	MQ = 'MQ',
	RE = 'RE',
	YT = 'YT',
	PF = 'PF',
	MC = 'MC',
	AT = 'AT',
	BE = 'BE',
	CA = 'CA',
	HR = 'HR',
	DK = 'DK',
	FI = 'FI',
	DE = 'DE',
	GR = 'GR',
	IT = 'IT',
	LU = 'LU',
	MT = 'MT',
	NL = 'NL',
	PL = 'PL',
	PT = 'PT',
	NO = 'NO',
	SE = 'SE',
	CH = 'CH'
}

export type Country = {
	iso: CountryISO
	name: CountryName
	flag: string
	phone: string
}

export type AlphaTwoFormattedCountry = {
	code: string
	flag: string
	nameFr: string
	nameEn: string
}

export const authorizedCountryList: Country[] = [
	{
		iso: CountryISO.GB,
		name: CountryName.UNITED_KINGDOM,
		phone: '+44',
		flag: '🇬🇧'
	},
	{
		iso: CountryISO.IE,
		name: CountryName.IRELAND,
		phone: '+353',
		flag: '🇮🇪'
	},
	{
		iso: CountryISO.ES,
		name: CountryName.ESPANA,
		phone: '+34',
		flag: '🇪🇸'
	},
	{
		iso: CountryISO.FR,
		name: CountryName.FRANCE,
		phone: '+33',
		flag: '🇫🇷'
	},
	{
		iso: CountryISO.GP,
		name: CountryName.GUADELOUPE,
		phone: '+590',
		flag: '🇬🇵'
	},
	{
		iso: CountryISO.GF,
		name: CountryName.GUYANNE,
		phone: '+594',
		flag: '🇬🇫'
	},
	{
		iso: CountryISO.MQ,
		name: CountryName.MARTINIQUE,
		phone: '+596',
		flag: '🇲🇶'
	},
	{
		iso: CountryISO.RE,
		name: CountryName.ILE_DE_LA_REUNION,
		phone: '+262',
		flag: '🇷🇪'
	},
	{
		iso: CountryISO.PF,
		name: CountryName.POLYNESIE_FRANCAISE,
		phone: '+689',
		flag: '🇵🇫'
	},
	{
		iso: CountryISO.MC,
		name: CountryName.MONACO,
		phone: '+377',
		flag: '🇲🇨'
	},
	{
		iso: CountryISO.AT,
		name: CountryName.AUSTRIA,
		phone: '+43',
		flag: '🇦🇹'
	},
	{
		iso: CountryISO.BE,
		name: CountryName.BELGIQUE,
		phone: '+32',
		flag: '🇧🇪'
	},
	{
		iso: CountryISO.CA,
		name: CountryName.CANADA,
		phone: '+1',
		flag: '🇨🇦'
	},
	{
		iso: CountryISO.HR,
		name: CountryName.CROATIA,
		phone: '+385',
		flag: '🇭🇷'
	},
	{
		iso: CountryISO.DK,
		name: CountryName.DENMARK,
		phone: '+45',
		flag: '🇩🇰'
	},
	{
		iso: CountryISO.FI,
		name: CountryName.FINLAND,
		phone: '+358',
		flag: '🇫🇮'
	},
	{
		iso: CountryISO.DE,
		name: CountryName.GERMANY,
		phone: '+49',
		flag: '🇩🇪'
	},
	{
		iso: CountryISO.GR,
		name: CountryName.GREECE,
		phone: '+30',
		flag: '🇬🇷'
	},
	{
		iso: CountryISO.IT,
		name: CountryName.ITALIA,
		phone: '+39',
		flag: '🇮🇹'
	},
	{
		iso: CountryISO.LU,
		name: CountryName.LUXEMBOURG,
		phone: '+352',
		flag: '🇱🇺'
	},
	{
		iso: CountryISO.MT,
		name: CountryName.MALTA,
		phone: '+356',
		flag: '🇲🇹'
	},
	{
		iso: CountryISO.NL,
		name: CountryName.NEDERLAN,
		phone: '+31',
		flag: '🇳🇱'
	},
	{
		iso: CountryISO.PL,
		name: CountryName.POLSKA,
		phone: '+48',
		flag: '🇵🇱'
	},
	{
		iso: CountryISO.PT,
		name: CountryName.PORTUGAL,
		phone: '+351',
		flag: '🇵🇹'
	},
	{
		iso: CountryISO.NO,
		name: CountryName.NORWAY,
		phone: '+47',
		flag: '🇳🇴'
	},
	{
		iso: CountryISO.SE,
		name: CountryName.SWEDEN,
		phone: '+46',
		flag: '🇸🇪'
	},
	{
		iso: CountryISO.CH,
		name: CountryName.SWITZERLAND,
		phone: '+41',
		flag: '🇨🇭'
	}
]

export const alphaTwoFormattedCountries: AlphaTwoFormattedCountry[] = [
	{
		code: 'FR',
		flag: '🇫🇷',
		nameFr: 'France',
		nameEn: 'France'
	},
	{
		code: 'AD',
		flag: '🇦🇩',
		nameFr: 'Andorre',
		nameEn: 'Andorra'
	},
	{
		code: 'AE',
		flag: '🇦🇪',
		nameFr: 'Émirats arabes unis',
		nameEn: 'United Arab Emirates'
	},
	{
		code: 'AF',
		flag: '🇦🇫',
		nameFr: 'Afghanistan',
		nameEn: 'Afghanistan'
	},
	{
		code: 'AG',
		flag: '🇦🇬',
		nameFr: 'Antigua-et-Barbuda',
		nameEn: 'Antigua \u0026 Barbuda'
	},
	{
		code: 'AI',
		flag: '🇦🇮',
		nameFr: 'Anguilla',
		nameEn: 'Anguilla'
	},
	{
		code: 'AL',
		flag: '🇦🇱',
		nameFr: 'Albanie',
		nameEn: 'Albania'
	},
	{
		code: 'AM',
		flag: '🇦🇲',
		nameFr: 'Arménie',
		nameEn: 'Armenia'
	},
	{
		code: 'AO',
		flag: '🇦🇴',
		nameFr: 'Angola',
		nameEn: 'Angola'
	},
	{
		code: 'AQ',
		flag: '🇦🇶',
		nameFr: 'Antarctique',
		nameEn: 'Antarctica'
	},
	{
		code: 'AS',
		flag: '🇦🇸',
		nameFr: 'Samoa américaines',
		nameEn: 'American Samoa'
	},
	{
		code: 'AR',
		flag: '🇦🇷',
		nameFr: 'Argentine',
		nameEn: 'Argentina'
	},
	{
		code: 'AT',
		flag: '🇦🇹',
		nameFr: 'Autriche',
		nameEn: 'Austria'
	},
	{
		code: 'AU',
		flag: '🇦🇺',
		nameFr: 'Australie',
		nameEn: 'Australia'
	},
	{
		code: 'AW',
		flag: '🇦🇼',
		nameFr: 'Aruba',
		nameEn: 'Aruba'
	},
	{
		code: 'AX',
		flag: '🇦🇽',
		nameFr: 'Îles Åland',
		nameEn: 'Åland Islands'
	},
	{
		code: 'AZ',
		flag: '🇦🇿',
		nameFr: 'Azerbaïdjan',
		nameEn: 'Azerbaijan'
	},
	{
		code: 'BA',
		flag: '🇧🇦',
		nameFr: 'Bosnie-Herzégovine',
		nameEn: 'Bosnia \u0026 Herzegovina'
	},
	{
		code: 'BB',
		flag: '🇧🇧',
		nameFr: 'Barbade',
		nameEn: 'Barbados'
	},
	{
		code: 'BD',
		flag: '🇧🇩',
		nameFr: 'Bangladesh',
		nameEn: 'Bangladesh'
	},
	{
		code: 'BE',
		flag: '🇧🇪',
		nameFr: 'Belgique',
		nameEn: 'Belgium'
	},
	{
		code: 'BF',
		flag: '🇧🇫',
		nameFr: 'Burkina Faso',
		nameEn: 'Burkina Faso'
	},
	{
		code: 'BG',
		flag: '🇧🇬',
		nameFr: 'Bulgarie',
		nameEn: 'Bulgaria'
	},
	{
		code: 'BH',
		flag: '🇧🇭',
		nameFr: 'Bahreïn',
		nameEn: 'Bahrain'
	},
	{
		code: 'BI',
		flag: '🇧🇮',
		nameFr: 'Burundi',
		nameEn: 'Burundi'
	},
	{
		code: 'BJ',
		flag: '🇧🇯',
		nameFr: 'Bénin',
		nameEn: 'Benin'
	},
	{
		code: 'BL',
		flag: '🇧🇱',
		nameFr: 'Saint-Barthélémy',
		nameEn: 'St. Barthélemy'
	},
	{
		code: 'BM',
		flag: '🇧🇲',
		nameFr: 'Bermudes',
		nameEn: 'Bermuda'
	},
	{
		code: 'BN',
		flag: '🇧🇳',
		nameFr: 'Brunéi Darussalam',
		nameEn: 'Brunei'
	},
	{
		code: 'BO',
		flag: '🇧🇴',
		nameFr: 'Bolivie',
		nameEn: 'Bolivia'
	},
	{
		code: 'BQ',
		flag: '🇧🇶',
		nameFr: 'Pays-Bas caribéens',
		nameEn: 'Caribbean Netherlands'
	},
	{
		code: 'BR',
		flag: '🇧🇷',
		nameFr: 'Brésil',
		nameEn: 'Brazil'
	},
	{
		code: 'BS',
		flag: '🇧🇸',
		nameFr: 'Bahamas',
		nameEn: 'Bahamas'
	},
	{
		code: 'BT',
		flag: '🇧🇹',
		nameFr: 'Bhoutan',
		nameEn: 'Bhutan'
	},
	{
		code: 'BV',
		flag: '🇧🇻',
		nameFr: 'Île Bouvet',
		nameEn: 'Bouvet Island'
	},
	{
		code: 'BW',
		flag: '🇧🇼',
		nameFr: 'Botswana',
		nameEn: 'Botswana'
	},
	{
		code: 'BY',
		flag: '🇧🇾',
		nameFr: 'Bélarus',
		nameEn: 'Belarus'
	},
	{
		code: 'BZ',
		flag: '🇧🇿',
		nameFr: 'Belize',
		nameEn: 'Belize'
	},
	{
		code: 'CA',
		flag: '🇨🇦',
		nameFr: 'Canada',
		nameEn: 'Canada'
	},
	{
		code: 'CC',
		flag: '🇨🇨',
		nameFr: 'Îles Cocos - Keeling',
		nameEn: 'Cocos (Keeling) Islands'
	},
	{
		code: 'CD',
		flag: '🇨🇩',
		nameFr: 'République démocratique du Congo',
		nameEn: 'Congo - Kinshasa'
	},
	{
		code: 'CF',
		flag: '🇨🇫',
		nameFr: 'République centrafricaine',
		nameEn: 'Central African Republic'
	},
	{
		code: 'CG',
		flag: '🇨🇬',
		nameFr: 'Congo-Brazzaville',
		nameEn: 'Congo - Brazzaville'
	},
	{
		code: 'CH',
		flag: '🇨🇭',
		nameFr: 'Suisse',
		nameEn: 'Switzerland'
	},
	{
		code: 'CI',
		flag: '🇨🇮',
		nameFr: 'Côte d’Ivoire',
		nameEn: 'Côte d’Ivoire'
	},
	{
		code: 'CK',
		flag: '🇨🇰',
		nameFr: 'Îles Cook',
		nameEn: 'Cook Islands'
	},
	{
		code: 'CL',
		flag: '🇨🇱',
		nameFr: 'Chili',
		nameEn: 'Chile'
	},
	{
		code: 'CM',
		flag: '🇨🇲',
		nameFr: 'Cameroun',
		nameEn: 'Cameroon'
	},
	{
		code: 'CN',
		flag: '🇨🇳',
		nameFr: 'Chine',
		nameEn: 'China'
	},
	{
		code: 'CO',
		flag: '🇨🇴',
		nameFr: 'Colombie',
		nameEn: 'Colombia'
	},
	{
		code: 'CR',
		flag: '🇨🇷',
		nameFr: 'Costa Rica',
		nameEn: 'Costa Rica'
	},
	{
		code: 'CU',
		flag: '🇨🇺',
		nameFr: 'Cuba',
		nameEn: 'Cuba'
	},
	{
		code: 'CV',
		flag: '🇨🇻',
		nameFr: 'Cap-Vert',
		nameEn: 'Cape Verde'
	},
	{
		code: 'CW',
		flag: '🇨🇼',
		nameFr: 'Curaçao',
		nameEn: 'Curaçao'
	},
	{
		code: 'CX',
		flag: '🇨🇽',
		nameFr: 'Île Christmas',
		nameEn: 'Christmas Island'
	},
	{
		code: 'CY',
		flag: '🇨🇾',
		nameFr: 'Chypre',
		nameEn: 'Cyprus'
	},
	{
		code: 'CZ',
		flag: '🇨🇿',
		nameFr: 'République tchèque',
		nameEn: 'Czechia'
	},
	{
		code: 'DE',
		flag: '🇩🇪',
		nameFr: 'Allemagne',
		nameEn: 'Germany'
	},
	{
		code: 'DJ',
		flag: '🇩🇯',
		nameFr: 'Djibouti',
		nameEn: 'Djibouti'
	},
	{
		code: 'DK',
		flag: '🇩🇰',
		nameFr: 'Danemark',
		nameEn: 'Denmark'
	},
	{
		code: 'DM',
		flag: '🇩🇲',
		nameFr: 'Dominique',
		nameEn: 'Dominica'
	},
	{
		code: 'DO',
		flag: '🇩🇴',
		nameFr: 'République dominicaine',
		nameEn: 'Dominican Republic'
	},
	{
		code: 'DZ',
		flag: '🇩🇿',
		nameFr: 'Algérie',
		nameEn: 'Algeria'
	},
	{
		code: 'EC',
		flag: '🇪🇨',
		nameFr: 'Équateur',
		nameEn: 'Ecuador'
	},
	{
		code: 'EE',
		flag: '🇪🇪',
		nameFr: 'Estonie',
		nameEn: 'Estonia'
	},
	{
		code: 'EG',
		flag: '🇪🇬',
		nameFr: 'Égypte',
		nameEn: 'Egypt'
	},
	{
		code: 'EH',
		flag: '🇪🇭',
		nameFr: 'Sahara occidental',
		nameEn: 'Western Sahara'
	},
	{
		code: 'ER',
		flag: '🇪🇷',
		nameFr: 'Érythrée',
		nameEn: 'Eritrea'
	},
	{
		code: 'ES',
		flag: '🇪🇸',
		nameFr: 'Espagne',
		nameEn: 'Spain'
	},
	{
		code: 'ET',
		flag: '🇪🇹',
		nameFr: 'Éthiopie',
		nameEn: 'Ethiopia'
	},
	{
		code: 'FI',
		flag: '🇫🇮',
		nameFr: 'Finlande',
		nameEn: 'Finland'
	},
	{
		code: 'FJ',
		flag: '🇫🇯',
		nameFr: 'Fidji',
		nameEn: 'Fiji'
	},
	{
		code: 'FK',
		flag: '🇫🇰',
		nameFr: 'Îles Malouines',
		nameEn: 'Falkland Islands'
	},
	{
		code: 'FM',
		flag: '🇫🇲',
		nameFr: 'États fédérés de Micronésie',
		nameEn: 'Micronesia'
	},
	{
		code: 'FO',
		flag: '🇫🇴',
		nameFr: 'Îles Féroé',
		nameEn: 'Faroe Islands'
	},
	{
		code: 'GA',
		flag: '🇬🇦',
		nameFr: 'Gabon',
		nameEn: 'Gabon'
	},
	{
		code: 'GB',
		flag: '🇬🇧',
		nameFr: 'Royaume-Uni',
		nameEn: 'United Kingdom'
	},
	{
		code: 'GD',
		flag: '🇬🇩',
		nameFr: 'Grenade',
		nameEn: 'Grenada'
	},
	{
		code: 'GE',
		flag: '🇬🇪',
		nameFr: 'Géorgie',
		nameEn: 'Georgia'
	},
	{
		code: 'GF',
		flag: '🇬🇫',
		nameFr: 'Guyane française',
		nameEn: 'French Guiana'
	},
	{
		code: 'GG',
		flag: '🇬🇬',
		nameFr: 'Guernesey',
		nameEn: 'Guernsey'
	},
	{
		code: 'GH',
		flag: '🇬🇭',
		nameFr: 'Ghana',
		nameEn: 'Ghana'
	},
	{
		code: 'GI',
		flag: '🇬🇮',
		nameFr: 'Gibraltar',
		nameEn: 'Gibraltar'
	},
	{
		code: 'GL',
		flag: '🇬🇱',
		nameFr: 'Groenland',
		nameEn: 'Greenland'
	},
	{
		code: 'GM',
		flag: '🇬🇲',
		nameFr: 'Gambie',
		nameEn: 'Gambia'
	},
	{
		code: 'GN',
		flag: '🇬🇳',
		nameFr: 'Guinée',
		nameEn: 'Guinea'
	},
	{
		code: 'GP',
		flag: '🇬🇵',
		nameFr: 'Guadeloupe',
		nameEn: 'Guadeloupe'
	},
	{
		code: 'GQ',
		flag: '🇬🇶',
		nameFr: 'Guinée équatoriale',
		nameEn: 'Equatorial Guinea'
	},
	{
		code: 'GR',
		flag: '🇬🇷',
		nameFr: 'Grèce',
		nameEn: 'Greece'
	},
	{
		code: 'GS',
		flag: '🇬🇸',
		nameFr: 'Géorgie du Sud et les îles Sandwich du Sud',
		nameEn: 'South Georgia \u0026 South Sandwich Islands'
	},
	{
		code: 'GT',
		flag: '🇬🇹',
		nameFr: 'Guatemala',
		nameEn: 'Guatemala'
	},
	{
		code: 'GU',
		flag: '🇬🇺',
		nameFr: 'Guam',
		nameEn: 'Guam'
	},
	{
		code: 'GW',
		flag: '🇬🇼',
		nameFr: 'Guinée-Bissau',
		nameEn: 'Guinea-Bissau'
	},
	{
		code: 'GY',
		flag: '🇬🇾',
		nameFr: 'Guyana',
		nameEn: 'Guyana'
	},
	{
		code: 'HK',
		flag: '🇭🇰',
		nameFr: 'R.A.S. chinoise de Hong Kong',
		nameEn: 'Hong Kong SAR China'
	},
	{
		code: 'HM',
		flag: '🇭🇲',
		nameFr: 'Îles Heard et MacDonald',
		nameEn: 'Heard \u0026 McDonald Islands'
	},
	{
		code: 'HN',
		flag: '🇭🇳',
		nameFr: 'Honduras',
		nameEn: 'Honduras'
	},
	{
		code: 'HR',
		flag: '🇭🇷',
		nameFr: 'Croatie',
		nameEn: 'Croatia'
	},
	{
		code: 'HT',
		flag: '🇭🇹',
		nameFr: 'Haïti',
		nameEn: 'Haiti'
	},
	{
		code: 'HU',
		flag: '🇭🇺',
		nameFr: 'Hongrie',
		nameEn: 'Hungary'
	},
	{
		code: 'ID',
		flag: '🇮🇩',
		nameFr: 'Indonésie',
		nameEn: 'Indonesia'
	},
	{
		code: 'IE',
		flag: '🇮🇪',
		nameFr: 'Irlande',
		nameEn: 'Ireland'
	},
	{
		code: 'IL',
		flag: '🇮🇱',
		nameFr: 'Israël',
		nameEn: 'Israel'
	},
	{
		code: 'IM',
		flag: '🇮🇲',
		nameFr: 'Île de Man',
		nameEn: 'Isle of Man'
	},
	{
		code: 'IN',
		flag: '🇮🇳',
		nameFr: 'Inde',
		nameEn: 'India'
	},
	{
		code: 'IO',
		flag: '🇮🇴',
		nameFr: 'Territoire britannique de l\u0027océan Indien',
		nameEn: 'British Indian Ocean Territory'
	},
	{
		code: 'IQ',
		flag: '🇮🇶',
		nameFr: 'Irak',
		nameEn: 'Iraq'
	},
	{
		code: 'IR',
		flag: '🇮🇷',
		nameFr: 'Iran',
		nameEn: 'Iran'
	},
	{
		code: 'IS',
		flag: '🇮🇸',
		nameFr: 'Islande',
		nameEn: 'Iceland'
	},
	{
		code: 'IT',
		flag: '🇮🇹',
		nameFr: 'Italie',
		nameEn: 'Italy'
	},
	{
		code: 'JE',
		flag: '🇯🇪',
		nameFr: 'Jersey',
		nameEn: 'Jersey'
	},
	{
		code: 'JM',
		flag: '🇯🇲',
		nameFr: 'Jamaïque',
		nameEn: 'Jamaica'
	},
	{
		code: 'JO',
		flag: '🇯🇴',
		nameFr: 'Jordanie',
		nameEn: 'Jordan'
	},
	{
		code: 'JP',
		flag: '🇯🇵',
		nameFr: 'Japon',
		nameEn: 'Japan'
	},
	{
		code: 'KE',
		flag: '🇰🇪',
		nameFr: 'Kenya',
		nameEn: 'Kenya'
	},
	{
		code: 'KG',
		flag: '🇰🇬',
		nameFr: 'Kirghizistan',
		nameEn: 'Kyrgyzstan'
	},
	{
		code: 'KH',
		flag: '🇰🇭',
		nameFr: 'Cambodge',
		nameEn: 'Cambodia'
	},
	{
		code: 'KI',
		flag: '🇰🇮',
		nameFr: 'Kiribati',
		nameEn: 'Kiribati'
	},
	{
		code: 'KM',
		flag: '🇰🇲',
		nameFr: 'Comores',
		nameEn: 'Comoros'
	},
	{
		code: 'KN',
		flag: '🇰🇳',
		nameFr: 'Saint-Kitts-et-Nevis',
		nameEn: 'St. Kitts \u0026 Nevis'
	},
	{
		code: 'KP',
		flag: '🇰🇵',
		nameFr: 'Corée du Nord',
		nameEn: 'North Korea'
	},
	{
		code: 'KR',
		flag: '🇰🇷',
		nameFr: 'Corée du Sud',
		nameEn: 'South Korea'
	},
	{
		code: 'KW',
		flag: '🇰🇼',
		nameFr: 'Koweït',
		nameEn: 'Kuwait'
	},
	{
		code: 'KY',
		flag: '🇰🇾',
		nameFr: 'Îles Caïmans',
		nameEn: 'Cayman Islands'
	},
	{
		code: 'KZ',
		flag: '🇰🇿',
		nameFr: 'Kazakhstan',
		nameEn: 'Kazakhstan'
	},
	{
		code: 'LA',
		flag: '🇱🇦',
		nameFr: 'Laos',
		nameEn: 'Laos'
	},
	{
		code: 'LB',
		flag: '🇱🇧',
		nameFr: 'Liban',
		nameEn: 'Lebanon'
	},
	{
		code: 'LC',
		flag: '🇱🇨',
		nameFr: 'Sainte-Lucie',
		nameEn: 'St. Lucia'
	},
	{
		code: 'LI',
		flag: '🇱🇮',
		nameFr: 'Liechtenstein',
		nameEn: 'Liechtenstein'
	},
	{
		code: 'LK',
		flag: '🇱🇰',
		nameFr: 'Sri Lanka',
		nameEn: 'Sri Lanka'
	},
	{
		code: 'LR',
		flag: '🇱🇷',
		nameFr: 'Libéria',
		nameEn: 'Liberia'
	},
	{
		code: 'LS',
		flag: '🇱🇸',
		nameFr: 'Lesotho',
		nameEn: 'Lesotho'
	},
	{
		code: 'LT',
		flag: '🇱🇹',
		nameFr: 'Lituanie',
		nameEn: 'Lithuania'
	},
	{
		code: 'LU',
		flag: '🇱🇺',
		nameFr: 'Luxembourg',
		nameEn: 'Luxembourg'
	},
	{
		code: 'LV',
		flag: '🇱🇻',
		nameFr: 'Lettonie',
		nameEn: 'Latvia'
	},
	{
		code: 'LY',
		flag: '🇱🇾',
		nameFr: 'Libye',
		nameEn: 'Libya'
	},
	{
		code: 'MA',
		flag: '🇲🇦',
		nameFr: 'Maroc',
		nameEn: 'Morocco'
	},
	{
		code: 'MC',
		flag: '🇲🇨',
		nameFr: 'Monaco',
		nameEn: 'Monaco'
	},
	{
		code: 'MD',
		flag: '🇲🇩',
		nameFr: 'Moldavie',
		nameEn: 'Moldova'
	},
	{
		code: 'ME',
		flag: '🇲🇪',
		nameFr: 'Monténégro',
		nameEn: 'Montenegro'
	},
	{
		code: 'MF',
		flag: '🇲🇫',
		nameFr: 'Saint-Martin',
		nameEn: 'St. Martin'
	},
	{
		code: 'MG',
		flag: '🇲🇬',
		nameFr: 'Madagascar',
		nameEn: 'Madagascar'
	},
	{
		code: 'MH',
		flag: '🇲🇭',
		nameFr: 'Îles Marshall',
		nameEn: 'Marshall Islands'
	},
	{
		code: 'MK',
		flag: '🇲🇰',
		nameFr: 'Macédoine',
		nameEn: 'Macedonia'
	},
	{
		code: 'ML',
		flag: '🇲🇱',
		nameFr: 'Mali',
		nameEn: 'Mali'
	},
	{
		code: 'MM',
		flag: '🇲🇲',
		nameFr: 'Myanmar',
		nameEn: 'Myanmar (Burma)'
	},
	{
		code: 'MN',
		flag: '🇲🇳',
		nameFr: 'Mongolie',
		nameEn: 'Mongolia'
	},
	{
		code: 'MO',
		flag: '🇲🇴',
		nameFr: 'R.A.S. chinoise de Macao',
		nameEn: 'Macau SAR China'
	},
	{
		code: 'MP',
		flag: '🇲🇵',
		nameFr: 'Îles Mariannes du Nord',
		nameEn: 'Northern Mariana Islands'
	},
	{
		code: 'MQ',
		flag: '🇲🇶',
		nameFr: 'Martinique',
		nameEn: 'Martinique'
	},
	{
		code: 'MR',
		flag: '🇲🇷',
		nameFr: 'Mauritanie',
		nameEn: 'Mauritania'
	},
	{
		code: 'MS',
		flag: '🇲🇸',
		nameFr: 'Montserrat',
		nameEn: 'Montserrat'
	},
	{
		code: 'MT',
		flag: '🇲🇹',
		nameFr: 'Malte',
		nameEn: 'Malta'
	},
	{
		code: 'MU',
		flag: '🇲🇺',
		nameFr: 'Maurice',
		nameEn: 'Mauritius'
	},
	{
		code: 'MV',
		flag: '🇲🇻',
		nameFr: 'Maldives',
		nameEn: 'Maldives'
	},
	{
		code: 'MW',
		flag: '🇲🇼',
		nameFr: 'Malawi',
		nameEn: 'Malawi'
	},
	{
		code: 'MX',
		flag: '🇲🇽',
		nameFr: 'Mexique',
		nameEn: 'Mexico'
	},
	{
		code: 'MY',
		flag: '🇲🇾',
		nameFr: 'Malaisie',
		nameEn: 'Malaysia'
	},
	{
		code: 'MZ',
		flag: '🇲🇿',
		nameFr: 'Mozambique',
		nameEn: 'Mozambique'
	},
	{
		code: 'NA',
		flag: '🇳🇦',
		nameFr: 'Namibie',
		nameEn: 'Namibia'
	},
	{
		code: 'NC',
		flag: '🇳🇨',
		nameFr: 'Nouvelle-Calédonie',
		nameEn: 'New Caledonia'
	},
	{
		code: 'NE',
		flag: '🇳🇪',
		nameFr: 'Niger',
		nameEn: 'Niger'
	},
	{
		code: 'NF',
		flag: '🇳🇫',
		nameFr: 'Île Norfolk',
		nameEn: 'Norfolk Island'
	},
	{
		code: 'NG',
		flag: '🇳🇬',
		nameFr: 'Nigéria',
		nameEn: 'Nigeria'
	},
	{
		code: 'NI',
		flag: '🇳🇮',
		nameFr: 'Nicaragua',
		nameEn: 'Nicaragua'
	},
	{
		code: 'NL',
		flag: '🇳🇱',
		nameFr: 'Pays-Bas',
		nameEn: 'Netherlands'
	},
	{
		code: 'NO',
		flag: '🇳🇴',
		nameFr: 'Norvège',
		nameEn: 'Norway'
	},
	{
		code: 'NP',
		flag: '🇳🇵',
		nameFr: 'Népal',
		nameEn: 'Nepal'
	},
	{
		code: 'NR',
		flag: '🇳🇷',
		nameFr: 'Nauru',
		nameEn: 'Nauru'
	},
	{
		code: 'NU',
		flag: '🇳🇺',
		nameFr: 'Niue',
		nameEn: 'Niue'
	},
	{
		code: 'NZ',
		flag: '🇳🇿',
		nameFr: 'Nouvelle-Zélande',
		nameEn: 'New Zealand'
	},
	{
		code: 'OM',
		flag: '🇴🇲',
		nameFr: 'Oman',
		nameEn: 'Oman'
	},
	{
		code: 'PA',
		flag: '🇵🇦',
		nameFr: 'Panama',
		nameEn: 'Panama'
	},
	{
		code: 'PE',
		flag: '🇵🇪',
		nameFr: 'Pérou',
		nameEn: 'Peru'
	},
	{
		code: 'PF',
		flag: '🇵🇫',
		nameFr: 'Polynésie française',
		nameEn: 'French Polynesia'
	},
	{
		code: 'PG',
		flag: '🇵🇬',
		nameFr: 'Papouasie-Nouvelle-Guinée',
		nameEn: 'Papua New Guinea'
	},
	{
		code: 'PH',
		flag: '🇵🇭',
		nameFr: 'Philippines',
		nameEn: 'Philippines'
	},
	{
		code: 'PK',
		flag: '🇵🇰',
		nameFr: 'Pakistan',
		nameEn: 'Pakistan'
	},
	{
		code: 'PL',
		flag: '🇵🇱',
		nameFr: 'Pologne',
		nameEn: 'Poland'
	},
	{
		code: 'PM',
		flag: '🇵🇲',
		nameFr: 'Saint-Pierre-et-Miquelon',
		nameEn: 'St. Pierre \u0026 Miquelon'
	},
	{
		code: 'PN',
		flag: '🇵🇳',
		nameFr: 'Pitcairn',
		nameEn: 'Pitcairn Islands'
	},
	{
		code: 'PR',
		flag: '🇵🇷',
		nameFr: 'Porto Rico',
		nameEn: 'Puerto Rico'
	},
	{
		code: 'PS',
		flag: '🇵🇸',
		nameFr: 'Territoire palestinien',
		nameEn: 'Palestinian Territories'
	},
	{
		code: 'PT',
		flag: '🇵🇹',
		nameFr: 'Portugal',
		nameEn: 'Portugal'
	},
	{
		code: 'PW',
		flag: '🇵🇼',
		nameFr: 'Palaos',
		nameEn: 'Palau'
	},
	{
		code: 'PY',
		flag: '🇵🇾',
		nameFr: 'Paraguay',
		nameEn: 'Paraguay'
	},
	{
		code: 'QA',
		flag: '🇶🇦',
		nameFr: 'Qatar',
		nameEn: 'Qatar'
	},
	{
		code: 'RE',
		flag: '🇷🇪',
		nameFr: 'Réunion',
		nameEn: 'Réunion'
	},
	{
		code: 'RO',
		flag: '🇷🇴',
		nameFr: 'Roumanie',
		nameEn: 'Romania'
	},
	{
		code: 'RS',
		flag: '🇷🇸',
		nameFr: 'Serbie',
		nameEn: 'Serbia'
	},
	{
		code: 'RU',
		flag: '🇷🇺',
		nameFr: 'Russie',
		nameEn: 'Russia'
	},
	{
		code: 'RW',
		flag: '🇷🇼',
		nameFr: 'Rwanda',
		nameEn: 'Rwanda'
	},
	{
		code: 'SA',
		flag: '🇸🇦',
		nameFr: 'Arabie saoudite',
		nameEn: 'Saudi Arabia'
	},
	{
		code: 'SB',
		flag: '🇸🇧',
		nameFr: 'Îles Salomon',
		nameEn: 'Solomon Islands'
	},
	{
		code: 'SC',
		flag: '🇸🇨',
		nameFr: 'Seychelles',
		nameEn: 'Seychelles'
	},
	{
		code: 'SD',
		flag: '🇸🇩',
		nameFr: 'Soudan',
		nameEn: 'Sudan'
	},
	{
		code: 'SE',
		flag: '🇸🇪',
		nameFr: 'Suède',
		nameEn: 'Sweden'
	},
	{
		code: 'SG',
		flag: '🇸🇬',
		nameFr: 'Singapour',
		nameEn: 'Singapore'
	},
	{
		code: 'SH',
		flag: '🇸🇭',
		nameFr: 'Sainte-Hélène',
		nameEn: 'St. Helena'
	},
	{
		code: 'SI',
		flag: '🇸🇮',
		nameFr: 'Slovénie',
		nameEn: 'Slovenia'
	},
	{
		code: 'SJ',
		flag: '🇸🇯',
		nameFr: 'Svalbard et Île Jan Mayen',
		nameEn: 'Svalbard \u0026 Jan Mayen'
	},
	{
		code: 'SK',
		flag: '🇸🇰',
		nameFr: 'Slovaquie',
		nameEn: 'Slovakia'
	},
	{
		code: 'SL',
		flag: '🇸🇱',
		nameFr: 'Sierra Leone',
		nameEn: 'Sierra Leone'
	},
	{
		code: 'SM',
		flag: '🇸🇲',
		nameFr: 'Saint-Marin',
		nameEn: 'San Marino'
	},
	{
		code: 'SN',
		flag: '🇸🇳',
		nameFr: 'Sénégal',
		nameEn: 'Senegal'
	},
	{
		code: 'SO',
		flag: '🇸🇴',
		nameFr: 'Somalie',
		nameEn: 'Somalia'
	},
	{
		code: 'SR',
		flag: '🇸🇷',
		nameFr: 'Suriname',
		nameEn: 'Suriname'
	},
	{
		code: 'SS',
		flag: '🇸🇸',
		nameFr: 'Soudan du sud',
		nameEn: 'South Sudan'
	},
	{
		code: 'ST',
		flag: '🇸🇹',
		nameFr: 'Sao Tomé-et-Principe',
		nameEn: 'São Tomé \u0026 Príncipe'
	},
	{
		code: 'SV',
		flag: '🇸🇻',
		nameFr: 'El Salvador',
		nameEn: 'El Salvador'
	},
	{
		code: 'SX',
		flag: '🇸🇽',
		nameFr: 'Saint Martin',
		nameEn: 'Sint Maarten'
	},
	{
		code: 'SY',
		flag: '🇸🇾',
		nameFr: 'Syrie',
		nameEn: 'Syria'
	},
	{
		code: 'SZ',
		flag: '🇸🇿',
		nameFr: 'Swaziland',
		nameEn: 'Swaziland'
	},
	{
		code: 'TC',
		flag: '🇹🇨',
		nameFr: 'Îles Turks et Caïques',
		nameEn: 'Turks \u0026 Caicos Islands'
	},
	{
		code: 'TD',
		flag: '🇹🇩',
		nameFr: 'Tchad',
		nameEn: 'Chad'
	},
	{
		code: 'TF',
		flag: '🇹🇫',
		nameFr: 'Terres australes françaises',
		nameEn: 'French Southern Territories'
	},
	{
		code: 'TG',
		flag: '🇹🇬',
		nameFr: 'Togo',
		nameEn: 'Togo'
	},
	{
		code: 'TH',
		flag: '🇹🇭',
		nameFr: 'Thaïlande',
		nameEn: 'Thailand'
	},
	{
		code: 'TJ',
		flag: '🇹🇯',
		nameFr: 'Tadjikistan',
		nameEn: 'Tajikistan'
	},
	{
		code: 'TK',
		flag: '🇹🇰',
		nameFr: 'Tokelau',
		nameEn: 'Tokelau'
	},
	{
		code: 'TL',
		flag: '🇹🇱',
		nameFr: 'Timor oriental',
		nameEn: 'Timor-Leste'
	},
	{
		code: 'TM',
		flag: '🇹🇲',
		nameFr: 'Turkménistan',
		nameEn: 'Turkmenistan'
	},
	{
		code: 'TN',
		flag: '🇹🇳',
		nameFr: 'Tunisie',
		nameEn: 'Tunisia'
	},
	{
		code: 'TO',
		flag: '🇹🇴',
		nameFr: 'Tonga',
		nameEn: 'Tonga'
	},
	{
		code: 'TR',
		flag: '🇹🇷',
		nameFr: 'Turquie',
		nameEn: 'Turkey'
	},
	{
		code: 'TT',
		flag: '🇹🇹',
		nameFr: 'Trinité-et-Tobago',
		nameEn: 'Trinidad \u0026 Tobago'
	},
	{
		code: 'TV',
		flag: '🇹🇻',
		nameFr: 'Tuvalu',
		nameEn: 'Tuvalu'
	},
	{
		code: 'TW',
		flag: '🇹🇼',
		nameFr: 'Taïwan',
		nameEn: 'Taiwan'
	},
	{
		code: 'TZ',
		flag: '🇹🇿',
		nameFr: 'Tanzanie',
		nameEn: 'Tanzania'
	},
	{
		code: 'UA',
		flag: '🇺🇦',
		nameFr: 'Ukraine',
		nameEn: 'Ukraine'
	},
	{
		code: 'UG',
		flag: '🇺🇬',
		nameFr: 'Ouganda',
		nameEn: 'Uganda'
	},
	{
		code: 'UM',
		flag: '🇺🇲',
		nameFr: 'Îles mineures éloignées des États-Unis',
		nameEn: 'U.S. Outlying Islands'
	},
	{
		code: 'US',
		flag: '🇺🇲',
		nameFr: 'États-Unis',
		nameEn: 'United States'
	},
	{
		code: 'UY',
		flag: '🇺🇾',
		nameFr: 'Uruguay',
		nameEn: 'Uruguay'
	},
	{
		code: 'UZ',
		flag: '🇺🇿',
		nameFr: 'Ouzbékistan',
		nameEn: 'Uzbekistan'
	},
	{
		code: 'VA',
		flag: '🇻🇦',
		nameFr: 'État de la Cité du Vatican',
		nameEn: 'Vatican City'
	},
	{
		code: 'VC',
		flag: '🇻🇨',
		nameFr: 'Saint-Vincent-et-les Grenadines',
		nameEn: 'St. Vincent \u0026 Grenadines'
	},
	{
		code: 'VE',
		flag: '🇻🇪',
		nameFr: 'Venezuela',
		nameEn: 'Venezuela'
	},
	{
		code: 'VG',
		flag: '🇻🇬',
		nameFr: 'Îles Vierges britanniques',
		nameEn: 'British Virgin Islands'
	},
	{
		code: 'VI',
		flag: '🇺🇲',
		nameFr: 'Îles Vierges des États-Unis',
		nameEn: 'U.S. Virgin Islands'
	},
	{
		code: 'VN',
		flag: '🇻🇳',
		nameFr: 'Viêt Nam',
		nameEn: 'Vietnam'
	},
	{
		code: 'VU',
		flag: '🇻🇺',
		nameFr: 'Vanuatu',
		nameEn: 'Vanuatu'
	},
	{
		code: 'WF',
		flag: '🇼🇫',
		nameFr: 'Wallis-et-Futuna',
		nameEn: 'Wallis \u0026 Futuna'
	},
	{
		code: 'WS',
		flag: '🇼🇸',
		nameFr: 'Samoa',
		nameEn: 'Samoa'
	},
	{
		code: 'YE',
		flag: '🇾🇪',
		nameFr: 'Yémen',
		nameEn: 'Yemen'
	},
	{
		code: 'YT',
		flag: '🇾🇹',
		nameFr: 'Mayotte',
		nameEn: 'Mayotte'
	},
	{
		code: 'ZA',
		flag: '🇿🇦',
		nameFr: 'Afrique du Sud',
		nameEn: 'South Africa'
	},
	{
		code: 'ZM',
		flag: '🇿🇲',
		nameFr: 'Zambie',
		nameEn: 'Zambia'
	},
	{
		code: 'ZW',
		flag: '🇿🇼',
		nameFr: 'Zimbabwe',
		nameEn: 'Zimbabwe'
	}
]
